import { Menu, MenuListItem, IconButton, IconMoreVert, Loader } from 'cdk-radial';
import React, {useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './ActiveSubscriptionsTable.scss';
import { setScreen } from '../../../../redux/connectedComponent/uiFactory/uiFactory.slice';
import { screens } from '../../../config/uiFactory.config'
import { setRemoveLocationsInitialStates } from '../../../../redux/connectedComponent/removeLocations/removeLocations.slice';
import { setLocationsAsPerApp } from '../../../../redux/connectedComponent/loginDetails/loginDetails.slice';
import Overlay from '../../../Overlay/Overlay';
import RadioGroup from '../../../RadioGroup/RadioGroup';
import PlanHtmlBuilder from '../../menuOptions/addLocations/PlanHTMLBuilder';
import { clearSolutionInfo, getSolutionInfo } from '../../../../redux/connectedComponent/solutionInfo/solutionInfo.slice';
import { getURL} from '../../../../redux/connectedComponent/provisionSettings/provisionSettings.slice';
import { environmentURLs } from '../../../common/CaptureEnvironment';
import { getSolution } from '../../../../redux/connectedComponent/privacyProtection/privacyProtection.slice';
import {
  getDMSInfoBasedOnApis,
} from '../../../../redux/connectedComponent/selectedDMS/selectedDMS.slice';
import { sendAmplitudeData } from '../../../../utils/amplitude';
import { AMPLITUDE_EVENTS, AMPLITUDE_PROPERTIES } from '../../../../constants/amplitudeConstants';
import { API_TYPES } from '../../../../constants/APIDirectoryConstants';
import { resetDealerApiPreferencesUpdateStatus } from '../../../../redux/connectedComponent/dealerApiPreferences/dealerApiPreferences.slice';

const CustomContextMenu = (props) => {

  const dispatch = useDispatch();

  const state = useSelector(state => state);

  const loginDetailsState  = state && state.loginDetailsSlice;
  let token = (loginDetailsState && loginDetailsState.authenticationToken) || '';

  const planDetails = state && state.solutionInfoSlice && state.solutionInfoSlice.planDetails;
  const dmsSupported = state?.selectDMSSlice?.dmsSupported;
  const verticalScopingSupported = state?.selectDMSSlice?.verticalScopingSupported;

  let { gridParams } = props;

  const { data } = gridParams;

  const solutionData = data.solutionData;
  const subscribedOn = data.subscribedOn;
  const isBulkSubscribed = data.isBulkSubscribed;

  const subscriptionData = data.subscriptionData;
  const [planWindowDialog, setPlanWindowDialog] = useState(false);
  const [selectedPlanId, setSelectedPlanId] = useState('');
  const [disableProceed, setDisableProceed]=useState(true);
  const [planList, setPlanList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [menuOptions, setMenuOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState({});

  const targetRef = useRef();
  const entityIdRedirection = solutionData && solutionData.provisioning_interface && solutionData.provisioning_interface.entityID && solutionData.provisioning_interface.entityID  === true;
  const redirectUrl = solutionData && solutionData.provisioning_interface && solutionData.provisioning_interface.redirectURL;
  const apis = data?.solutionData?.registration_details?.api_details?.map(api => ({apiType: api.apiType, id: api.id})) ?? [];
  const appId = data?.solutionData?.id;

  const checkVSOptionFlag = (options) => {
    if(environmentURLs.REACT_APP_SHOW_VERTICAL_SCOPING_SCREEN) {
      options.push({ label: 'Manage Field Filtering' });
    }
  }

  const isRestApiIntegratedInApp =
    Array.isArray(apis) && apis.some((api) => api.apiType === API_TYPES.REST);

  useEffect(() => {
    let options = [
      { label: 'Add Locations' },
      { label: 'Remove Locations' },
      { label: 'Manage Integration' },
      { label: 'App Documents' },
      { label: 'Unsubscribe' }
    ];
    checkVSOptionFlag(options);
    let dmsOptionFlag = false;
    subscriptionData && subscriptionData.forEach(item => {
      if(!dmsOptionFlag){
        const entityIdList = item.entityIdList;
        entityIdList && entityIdList.forEach(entity => {
          if(entity.hasOwnProperty('dmsAccount')){
            dmsOptionFlag = true;
          }
        });
      }
    });

    if (dmsOptionFlag) {
      options.splice(2, 0, {
        label: screens.MANAGE_DMS_ACCOUNTS
      });
    }

    if (isRestApiIntegratedInApp) {
      options.splice(3, 0, {
        label: screens.MANAGE_API_SUBSCRIPTION_SETTINGS,
      });
    }

    if(data.isBulkSubscribed){
      options = [
        {label: 'Add Locations' },
        {label : 'Remove Locations'},
        {label : 'Manage Integration'},
        {label : 'Unsubscribe'}
      ];

      if(dmsSupported[appId]) {
        options.splice(2, 0, {
          label: screens.MANAGE_DMS_ACCOUNTS
        });
      }
      if (
        verticalScopingSupported &&
        verticalScopingSupported[appId] &&
        Object.values(verticalScopingSupported[appId]).length > 0
      ) {
        options.push({
          label: screens.MANAGE_VERTICAL_SCOPING,
        });
      }
    }

    if(solutionData.isAppNotListed){
      options = [
        {label : 'Remove Locations'},
        {label : 'Manage Integration'},
        {label : 'Unsubscribe'}
      ];
      if (
        verticalScopingSupported &&
        verticalScopingSupported[appId] &&
        Object.values(verticalScopingSupported[appId]).length > 0
      ) {
        options.push({
          label: screens.MANAGE_VERTICAL_SCOPING,
        });
      }
    }

    if (
      solutionData?.privacyProtection
    ) {
      options.splice(2, 0, {
        label: screens.MANAGE_PRIVACY_PROTECTION
      });
    }

    if (redirectUrl) {
      options.splice(0, 0, {label: 'Configure App'});
    }

    if(data.method==='Activation' || data.method==='Fortellis Admin'){
      let index = options.findIndex((option) => option.label==='Unsubscribe')
      options[index].label='Deactivate'
    }

    setLoading(false);
    setMenuOptions(options);
  }, [data.subscriptionData, dmsSupported, verticalScopingSupported]);

  const prepareAndSubmitAmplitudeData = (event) => {
    sendAmplitudeData(event, {
      [AMPLITUDE_PROPERTIES.APP_NAME]: solutionData?.overview?.name || solutionData?.displayName,
      [AMPLITUDE_PROPERTIES.APP_ID]: solutionData?.id,
    });
  }

  const handleSelect = (event) => {
    setSelectedOption(event);
    if (event.label === screens.ADD_LOCATIONS) {
      prepareAndSubmitAmplitudeData(AMPLITUDE_EVENTS.ADD_LOCATIONS);

      dispatch(clearSolutionInfo());
      setPlanList([]);
      dispatch(
        getSolutionInfo({
          solutionId: solutionData && solutionData.id,
          token,
        })
      );
      if (solutionData.activateOnly !== false) {
        window.open(
          `/dp/${solutionData.id}`,
          '_self'
        );
      } else {
         setPlanWindowDialog(true);
      }
    } else if (event.label === screens.REMOVE_LOCATIONS) {

      prepareAndSubmitAmplitudeData(AMPLITUDE_EVENTS.REMOVE_LOCATIONS);

      if (solutionData?.un_authorized_signon?.isEnabled) {
        dispatch(setLocationsAsPerApp({ unAuthTitleEnabled: solutionData.un_authorized_signon.isEnabled }));
      } else {
        dispatch(setLocationsAsPerApp({ unAuthTitleEnabled: false }));
      }
      dispatch(setRemoveLocationsInitialStates());
      dispatch(setScreen({
        screen: screens.REMOVE_LOCATIONS,
        solutionData: solutionData,
        additionalData: {
          subscriptionData: subscriptionData,
          isBulkSubscribed: data.isBulkSubscribed
        }
      }));
    } else if (event.label === screens.MANAGE_PRIVACY_PROTECTION) {
      prepareAndSubmitAmplitudeData(AMPLITUDE_EVENTS.MANAGE_PRIVACY_PROTECTION);

      if (solutionData.isAppNotListed)
        dispatch(getSolution({ solutionId: solutionData.id, token }));
      dispatch(setScreen({
        screen: screens.MANAGE_PRIVACY_PROTECTION,
        solutionData,
        additionalData: {
          subscriptionData,
          isAppNotListed: solutionData.isAppNotListed,
          isBulkSubscribed: data.isBulkSubscribed
        }
      }));
    } else if (event.label === screens.MANAGE_DMS_ACCOUNTS) {
      prepareAndSubmitAmplitudeData(AMPLITUDE_EVENTS.MANAGE_DMS_ACCOUNTS);

      dispatch(setScreen({
        screen: !isBulkSubscribed ? screens.MANAGE_DMS_ACCOUNTS : screens.MANAGE_DMS_ACCOUNTS_V2,
        solutionData: solutionData,
        additionalData: {
          subscriptionData: subscriptionData,
          isBulkSubscribed: data.isBulkSubscribed
        }
      }));
    } else if (event.label === screens.MANAGE_INTEGRATION) {
      prepareAndSubmitAmplitudeData(AMPLITUDE_EVENTS.MANAGE_INTEGRATIONS);

      if(solutionData && solutionData.un_authorized_signon && solutionData.un_authorized_signon.isEnabled){
        dispatch(setLocationsAsPerApp({unAuthTitleEnabled:solutionData.un_authorized_signon.isEnabled}));
      } else {
        dispatch(setLocationsAsPerApp({unAuthTitleEnabled: false}));
      }
      dispatch(setScreen({
        screen: screens.MANAGE_INTEGRATION,
        solutionData: solutionData,
        additionalData: {
          subscriptionData: subscriptionData,
          isBulkSubscribed,
          isAppNotListed: solutionData.isAppNotListed
        }
      }));
    } else if (event.label === 'Unsubscribe' || event.label === 'Deactivate') {
      prepareAndSubmitAmplitudeData(AMPLITUDE_EVENTS.SELECT_UNSUBSCRIBE);

      dispatch(setRemoveLocationsInitialStates());
      dispatch(setScreen({
        screen: screens.SUBSCRIPTION_MANAGEMENT,
        solutionData: solutionData,
        additionalData: {
          activateUnsubscription: true,
          subscriptionData: subscriptionData,
          isBulkSubscribed: data.isBulkSubscribed || solutionData.isAppNotListed
        }
      }));
    } else if (event.label === 'Configure App') {
      prepareAndSubmitAmplitudeData(AMPLITUDE_EVENTS.CONFIGURE_APP);

      let subscriptionIds = subscriptionData && subscriptionData.length && subscriptionData.map(subscription => subscription && subscription.subscriptionId);
      let entityIds = subscriptionData && subscriptionData.length && subscriptionData.map(subscription => subscription && subscription.entityId);
      if (entityIdRedirection)
      {
        dispatch(getURL({url: redirectUrl,type:'entityId', ids:entityIds.join(), token}));
      }else{
        dispatch(getURL({url: redirectUrl,type:'subscriptionId', ids:subscriptionIds.join(), token}));
      }
    } else if (event.label === screens.APP_CONSENTS){
      prepareAndSubmitAmplitudeData(AMPLITUDE_EVENTS.VIEW_DOCUMENTS);
      dispatch(setScreen({
        screen: screens.APP_CONSENTS,
        solutionData: solutionData,
        additionalData: {
          subscriptionData: subscriptionData
        }
      }));
    }
    else if(event.label ===  screens.MANAGE_VERTICAL_SCOPING){
      dispatch(setScreen({
        screen: screens.MANAGE_VERTICAL_SCOPING,
        solutionData: solutionData,
        additionalData: {
          subscriptionData: subscriptionData,
          isBulkSubscribed: data.isBulkSubscribed
        }
      }))
    }

    else if(event.label === screens.MANAGE_API_SUBSCRIPTION_SETTINGS){
      dispatch(resetDealerApiPreferencesUpdateStatus());
      dispatch(
        setScreen({
          screen: screens.MANAGE_API_SUBSCRIPTION_SETTINGS,
          solutionData: solutionData,
          additionalData: {
            subscriptionData: subscriptionData,
          },
        })
      );
    }
  };

  useEffect(() => {
    if(planDetails && planDetails.length >0){
        const plan= PlanHtmlBuilder({PlanData:planDetails})
        setPlanList(plan)
    }
  }, [planDetails]);

  const onSelectPlan = (plan) => {
    setDisableProceed(false);
    setSelectedPlanId(plan.props.id);
  }

  const onPlanDialigOverlayAccept =()=>{
    window.open(`/dp/${solutionData.id}/${selectedPlanId}`, '_self');
  }

  const checkDMSSupport = () => {
    if (solutionData?.isAppNotListed) {
      const apiList = [];
      Array.isArray(solutionData.apiProducts) &&
        solutionData.apiProducts.forEach((api) => {
          apiList.push({ apiType: 'api', id: api });
        });

      Array.isArray(solutionData.asyncApiIntegrations) &&
        solutionData.asyncApiIntegrations.forEach((item) => {
          apiList.push({ apiType: 'async-api', id: item.asyncApiId });
        });

      if (
        !dmsSupported.hasOwnProperty(appId) ||
        (isBulkSubscribed && !verticalScopingSupported.hasOwnProperty(appId))
      ) {
        setLoading(true);
        dispatch(
          getDMSInfoBasedOnApis({
            apis: apiList,
            token: token,
            appId,
            caller: 'CustomContextMenu',
          }),
        );
      }
    } else {
      if (
        !dmsSupported.hasOwnProperty(appId) ||
        (isBulkSubscribed && !verticalScopingSupported.hasOwnProperty(appId))
      ) {
        setLoading(true);
        dispatch(
          getDMSInfoBasedOnApis({
            apis,
            token: token,
            appId,
            caller: 'CustomContextMenu',
          }),
        );
      }
    }
  };

  return (
    <>
      <span className="active_subscribed-on">
        {subscribedOn ? subscribedOn : 'NA'}
      </span>
      <div className="active_context-menu">
        <IconButton
          icon={<IconMoreVert />}
          dataTestId="button"
          ref={targetRef}
          text=""
          onClick={() => {
            sendAmplitudeData(AMPLITUDE_EVENTS.MENU_EXPAND, {});

            if(isBulkSubscribed) {
              checkDMSSupport();
            }
          }}
        />
        <Menu
          labelRef={targetRef}
          isAuto={true}
          style={{ zIndex: 50, maxHeight: 'fit-content' }}
        >
          {
            loading ?
              <MenuListItem isDisabled={true}>Loading...</MenuListItem> :
              menuOptions.map((option, ind) => (
                <MenuListItem
                  key={ind}
                  isSelected={selectedOption.label === option.label}
                  onClick={() => handleSelect(option)}
                >
                  {option.label}
                </MenuListItem>
              ))
          }
        </Menu>
      </div>
      <Overlay
        active={planWindowDialog}
        title={`Choose Your Pricing Plan`}
        onOverlayClose={() => setPlanWindowDialog(false)}
        onOverlayAccept={onPlanDialigOverlayAccept}
        disableSecondButton={disableProceed}
      >
        {planList.length === 0 ? (
          <Loader
            data-testid="loader"
            hideLabel={false}
            label="Loading plan details..."
            spinnerClassName=""
            variant="inline"
          />
        ) : (
          <RadioGroup list={planList} onRadioSelection={onSelectPlan} />
        )}
      </Overlay>
    </>
  );
};

export default CustomContextMenu;
